export const RING_CENTER = 12;
export const RING_RADIUS = 8;
export const RING_STROKE = 2.6;
export const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
export const MAX_ARC = 0.72;

const ARROW_WIDTH = 6.6;
const ARROW_LENGTH = 3.6;
const PULL_TURN = 90;
const OVERPULL_TURN = 180;
const ENTER_DISTANCE = 40;
const ENTER_SCALE = 0.8;
const APPEAR_DISTANCE = 20;

const round = (value: number) => Number(value.toFixed(2));

const clampUnit = (value: number) => Math.min(1, Math.max(0, value));

export const getDiscScale = (distance: number, finish: number, pop: number) => {
  const enter = clampUnit(distance / ENTER_DISTANCE);
  return (ENTER_SCALE + (1 - ENTER_SCALE) * enter) * pop * (1 - finish);
};

export const getDiscOpacity = (distance: number, finish: number) =>
  clampUnit(distance / APPEAR_DISTANCE) * (1 - clampUnit((finish - 0.5) * 2));

export const getArcDash = (progress: number) => {
  const length = RING_CIRCUMFERENCE * MAX_ARC * progress;
  return `${round(length)} ${round(RING_CIRCUMFERENCE - length)}`;
};

export const getPullTurn = (distance: number, threshold: number) => {
  if (distance <= threshold) return (PULL_TURN * distance) / threshold;
  return PULL_TURN + (OVERPULL_TURN * (distance - threshold)) / threshold;
};

export const getArrowPath = (progress: number) => {
  const angle = 2 * Math.PI * MAX_ARC * progress;
  const size = Math.min(1, progress);
  const radial = { x: Math.sin(angle), y: -Math.cos(angle) };
  const tangent = { x: Math.cos(angle), y: Math.sin(angle) };
  const head = {
    x: RING_CENTER + RING_RADIUS * radial.x,
    y: RING_CENTER + RING_RADIUS * radial.y,
  };
  const halfWidth = (ARROW_WIDTH / 2) * size;
  const length = ARROW_LENGTH * size;
  const points = [
    [head.x + radial.x * halfWidth, head.y + radial.y * halfWidth],
    [head.x + tangent.x * length, head.y + tangent.y * length],
    [head.x - radial.x * halfWidth, head.y - radial.y * halfWidth],
  ];
  const [outer, tip, inner] = points.map(([x, y]) => `${round(x)} ${round(y)}`);
  return `M${outer} L${tip} L${inner} Z`;
};
